import { Switch } from 'src/design/atoms/Switch';
import { Textarea } from 'src/design/atoms/Textarea';
import React from 'react';
import { formatDate } from 'src/utils';
import { DailyProgressItemRequestDto } from 'src/api/FiretrolApiClient';
import { DailyDesignProgressTarget } from 'src/api/queries/dailys/useDailyDesignProgressSummary';
import { PhysicalProgressInput } from 'src/routes/Operations/Daily/components/PhysicalProgressInput';
import { StepProps } from './types';

export interface ProgressStepProps extends StepProps {
  onProgressChange: (progress: DailyProgressItemRequestDto[]) => void;
  designProgressRequest: DailyDesignProgressTarget;
  onStatusesSaved?: (progressItemIds: string[]) => void;
  error?: string;
}

export const ProgressStep: React.FC<ProgressStepProps> = ({
  values,
  setFieldValue,
  setFieldTouched,
  selectedJob,
  onProgressChange,
  designProgressRequest,
  onStatusesSaved,
  error,
}) => {
  return (
    <>
      <Switch
        label={`No Progress for ${formatDate(values.date)}`}
        checked={values.excludeProgress}
        onChange={(event) => {
          setFieldValue('excludeProgress', event.currentTarget.checked);
          setFieldTouched('excludeProgress', true, false);
        }}
      />

      {values.excludeProgress && (
        <Textarea
          label="Reason for exclusion"
          placeholder="Explain why progress is excluded..."
          value={values.exclusionProgressReason || ''}
          onChange={(e) =>
            setFieldValue('exclusionProgressReason', e.target.value)
          }
          maxLength={1000}
          rows={3}
          mt="md"
          withAsterisk
          error={error}
        />
      )}

      {!values.excludeProgress && selectedJob && (
        <PhysicalProgressInput
          jobId={selectedJob.id}
          initialProgress={values.progressItemRequests}
          onProgressChange={onProgressChange}
          jobLabel={`${selectedJob.jobNumber} - ${selectedJob.name}`}
          designProgressRequest={designProgressRequest}
          onStatusesSaved={onStatusesSaved}
        />
      )}
    </>
  );
};
